export enum COUNTRY {
    AF = 'AF',
    AL = 'AL',
    DZ = 'DZ',
    AS = 'AS',
    AD = 'AD',
    AO = 'AO',
    AI = 'AI',
    AQ = 'AQ',
    AG = 'AG',
    AR = 'AR',
    AM = 'AM',
    AW = 'AW',
    AU = 'AU',
    AT = 'AT',
    AZ = 'AZ',
    BS = 'BS',
    BH = 'BH',
    BD = 'BD',
    BB = 'BB',
    BY = 'BY',
    BE = 'BE',
    BZ = 'BZ',
    BJ = 'BJ',
    BM = 'BM',
    BT = 'BT',
    BO = 'BO',
    BA = 'BA',
    BW = 'BW',
    BV = 'BV',
    BR = 'BR',
    IO = 'IO',
    BN = 'BN',
    BG = 'BG',
    BF = 'BF',
    BI = 'BI',
    KH = 'KH',
    CM = 'CM',
    CA = 'CA',
    CV = 'CV',
    KY = 'KY',
    CF = 'CF',
    TD = 'TD',
    CL = 'CL',
    CN = 'CN',
    CX = 'CX',
    CC = 'CC',
    CO = 'CO',
    KM = 'KM',
    CG = 'CG',
    CD = 'CD',
    CK = 'CK',
    CR = 'CR',
    CI = 'CI',
    HR = 'HR',
    CU = 'CU',
    CY = 'CY',
    CZ = 'CZ',
    DK = 'DK',
    DJ = 'DJ',
    DM = 'DM',
    DO = 'DO',
    EC = 'EC',
    EG = 'EG',
    SV = 'SV',
    GQ = 'GQ',
    ER = 'ER',
    EE = 'EE',
    ET = 'ET',
    FK = 'FK',
    FO = 'FO',
    FJ = 'FJ',
    FI = 'FI',
    FR = 'FR',
    GF = 'GF',
    PF = 'PF',
    TF = 'TF',
    GA = 'GA',
    GM = 'GM',
    GE = 'GE',
    DE = 'DE',
    GH = 'GH',
    GI = 'GI',
    GR = 'GR',
    GL = 'GL',
    GD = 'GD',
    GP = 'GP',
    GU = 'GU',
    GT = 'GT',
    GG = 'GG',
    GN = 'GN',
    GW = 'GW',
    GY = 'GY',
    HT = 'HT',
    HM = 'HM',
    VA = 'VA',
    HN = 'HN',
    HK = 'HK',
    HU = 'HU',
    IS = 'IS',
    IN = 'IN',
    ID = 'ID',
    IR = 'IR',
    IQ = 'IQ',
    IE = 'IE',
    IM = 'IM',
    IL = 'IL',
    IT = 'IT',
    JM = 'JM',
    JP = 'JP',
    JE = 'JE',
    JO = 'JO',
    KZ = 'KZ',
    KE = 'KE',
    KI = 'KI',
    KP = 'KP',
    KR = 'KR',
    KW = 'KW',
    KG = 'KG',
    LA = 'LA',
    LV = 'LV',
    LB = 'LB',
    LS = 'LS',
    LR = 'LR',
    LY = 'LY',
    LI = 'LI',
    LT = 'LT',
    LU = 'LU',
    MO = 'MO',
    MK = 'MK',
    MG = 'MG',
    MW = 'MW',
    MY = 'MY',
    MV = 'MV',
    ML = 'ML',
    MT = 'MT',
    MH = 'MH',
    MQ = 'MQ',
    MR = 'MR',
    MU = 'MU',
    YT = 'YT',
    MX = 'MX',
    FM = 'FM',
    MD = 'MD',
    MC = 'MC',
    MN = 'MN',
    ME = 'ME',
    MS = 'MS',
    MA = 'MA',
    MZ = 'MZ',
    MM = 'MM',
    NA = 'NA',
    NR = 'NR',
    NP = 'NP',
    NL = 'NL',
    AN = 'AN',
    NC = 'NC',
    NZ = 'NZ',
    NI = 'NI',
    NE = 'NE',
    NG = 'NG',
    NU = 'NU',
    NF = 'NF',
    MP = 'MP',
    NO = 'NO',
    OM = 'OM',
    PK = 'PK',
    PW = 'PW',
    PS = 'PS',
    PA = 'PA',
    PG = 'PG',
    PY = 'PY',
    PE = 'PE',
    PH = 'PH',
    PN = 'PN',
    PL = 'PL',
    PT = 'PT',
    PR = 'PR',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RU = 'RU',
    RW = 'RW',
    SH = 'SH',
    KN = 'KN',
    LC = 'LC',
    PM = 'PM',
    VC = 'VC',
    WS = 'WS',
    SM = 'SM',
    ST = 'ST',
    SA = 'SA',
    SN = 'SN',
    RS = 'RS',
    SC = 'SC',
    SL = 'SL',
    SG = 'SG',
    SK = 'SK',
    SI = 'SI',
    SB = 'SB',
    SO = 'SO',
    ZA = 'ZA',
    GS = 'GS',
    SS = 'SS',
    ES = 'ES',
    LK = 'LK',
    SD = 'SD',
    SR = 'SR',
    SJ = 'SJ',
    SZ = 'SZ',
    SE = 'SE',
    CH = 'CH',
    SY = 'SY',
    TW = 'TW',
    TJ = 'TJ',
    TZ = 'TZ',
    TH = 'TH',
    TL = 'TL',
    TG = 'TG',
    TK = 'TK',
    TO = 'TO',
    TT = 'TT',
    TN = 'TN',
    TR = 'TR',
    TM = 'TM',
    TC = 'TC',
    TV = 'TV',
    UG = 'UG',
    UA = 'UA',
    AE = 'AE',
    GB = 'GB',
    US = 'US',
    UM = 'UM',
    UY = 'UY',
    UZ = 'UZ',
    VU = 'VU',
    VE = 'VE',
    VN = 'VN',
    VG = 'VG',
    VI = 'VI',
    WF = 'WF',
    EH = 'EH',
    YE = 'YE',
    ZM = 'ZM',
    ZW = 'ZW'
}

export enum US_STATE {
    AL = 'AL',
    AK = 'AK',
    AZ = 'AZ',
    AR = 'AR',
    CA = 'CA',
    CO = 'CO',
    CT = 'CT',
    DE = 'DE',
    DC = 'DC',
    FL = 'FL',
    GA = 'GA',
    HI = 'HI',
    ID = 'ID',
    IL = 'IL',
    IN = 'IN',
    IA = 'IA',
    KS = 'KS',
    KY = 'KY',
    LA = 'LA',
    ME = 'ME',
    MD = 'MD',
    MA = 'MA',
    MI = 'MI',
    MN = 'MN',
    MS = 'MS',
    MO = 'MO',
    MT = 'MT',
    NE = 'NE',
    NV = 'NV',
    NH = 'NH',
    NJ = 'NJ',
    NM = 'NM',
    NY = 'NY',
    NC = 'NC',
    ND = 'ND',
    OH = 'OH',
    OK = 'OK',
    OR = 'OR',
    PA = 'PA',
    RI = 'RI',
    SC = 'SC',
    SD = 'SD',
    TN = 'TN',
    TX = 'TX',
    UT = 'UT',
    VT = 'VT',
    VA = 'VA',
    WA = 'WA',
    WV = 'WV',
    WI = 'WI',
    WY = 'WY'
}

export enum ADDRESS_TYPE {
    BILLING = 'billing',
    SHIPPING = 'shipping'
}

export enum TIME_ZONE {
    UTC = 'UTC',

    US_HAWAII = 'US/Hawaii',
    US_ALASKA = 'US/Alaska',
    US_PACIFIC = 'US/Pacific',
    US_MOUNTAIN = 'US/Mountain',
    US_CENTRAL = 'US/Central',
    US_EASTERN = 'US/Eastern'
}

export const US_TIME_ZONES = [
    TIME_ZONE.US_HAWAII,
    TIME_ZONE.US_ALASKA,
    TIME_ZONE.US_PACIFIC,
    TIME_ZONE.US_MOUNTAIN,
    TIME_ZONE.US_CENTRAL,
    TIME_ZONE.US_EASTERN
] as const;

export type USTimeZone = typeof US_TIME_ZONES[number];

export const CORE_US_TIME_ZONES = [
    TIME_ZONE.US_EASTERN,
    TIME_ZONE.US_CENTRAL,
    TIME_ZONE.US_MOUNTAIN,
    TIME_ZONE.US_PACIFIC
] as const;

export type CoreUSTimeZone = typeof CORE_US_TIME_ZONES[number];

export enum CITY_TIME_ZONE {
    AMERICA_ADAK = 'America/Adak',
    AMERICA_ANCHORAGE = 'America/Anchorage',
    AMERICA_CHICAGO = 'America/Chicago',
    AMERICA_DETROIT = 'America/Detroit',
    AMERICA_INDIANA = 'America/Indiana',
    AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
    AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
    AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
    AMERICA_INDIANA_MICHIGAN_CITY = 'America/Indiana/Michigan_City',
    AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
    AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
    AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
    AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
    AMERICA_JUNEAU = 'America/Juneau',
    AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
    AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
    AMERICA_LOS_ANGELES = 'America/Los_Angeles',
    AMERICA_LOUISVILLE = 'America/Louisville',
    AMERICA_MANAGUA = 'America/Managua',
    AMERICA_MANAUS = 'America/Manaus',
    AMERICA_MARIGOT = 'America/Marigot',
    AMERICA_MARTINIQUE = 'America/Martinique',
    AMERICA_MATAMOROS = 'America/Matamoros',
    AMERICA_MAZATLAN = 'America/Mazatlan',
    AMERICA_METLAKATLA = 'America/Metlakatla',
    AMERICA_MENOMINEE = 'America/Menominee',
    AMERICA_MIQUELON = 'America/Miquelon',
    AMERICA_MONCTON = 'America/Moncton',
    AMERICA_MONTERREY = 'America/Monterrey',
    AMERICA_MONTREAL = 'America/Montreal',
    AMERICA_NEW_YORK = 'America/New_York',
    AMERICA_NOME = 'America/Nome',
    AMERICA_NASSAU = 'America/Nassau',
    AMERICA_PHOENIX = 'America/Phoenix',
    AMERICA_SITKA = 'America/Sitka',
    AMERICA_YAKUTAT = 'America/Yakutat'
}

export const US_STATE_TO_TIME_ZONES : {
    [State in US_STATE] : [ USTimeZone, ...ReadonlyArray<USTimeZone> ]
} = {
    [ US_STATE.AL ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.AK ]: [ TIME_ZONE.US_ALASKA ],
    [ US_STATE.AZ ]: [ TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.AR ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.CA ]: [ TIME_ZONE.US_PACIFIC ],
    [ US_STATE.CO ]: [ TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.CT ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.DC ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.DE ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.FL ]: [ TIME_ZONE.US_EASTERN, TIME_ZONE.US_CENTRAL ],
    [ US_STATE.GA ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.HI ]: [ TIME_ZONE.US_HAWAII ],
    [ US_STATE.ID ]: [ TIME_ZONE.US_MOUNTAIN, TIME_ZONE.US_PACIFIC ],
    [ US_STATE.IL ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.IN ]: [ TIME_ZONE.US_EASTERN, TIME_ZONE.US_CENTRAL ],
    [ US_STATE.IA ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.KS ]: [ TIME_ZONE.US_CENTRAL, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.KY ]: [ TIME_ZONE.US_EASTERN, TIME_ZONE.US_CENTRAL ],
    [ US_STATE.LA ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.ME ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.MD ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.MA ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.MI ]: [ TIME_ZONE.US_EASTERN, TIME_ZONE.US_CENTRAL ],
    [ US_STATE.MN ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.MS ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.MO ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.MT ]: [ TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.NE ]: [ TIME_ZONE.US_CENTRAL, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.NV ]: [ TIME_ZONE.US_PACIFIC, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.NH ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.NJ ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.NM ]: [ TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.NY ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.NC ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.ND ]: [ TIME_ZONE.US_CENTRAL, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.OH ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.OK ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.OR ]: [ TIME_ZONE.US_PACIFIC, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.PA ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.RI ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.SC ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.SD ]: [ TIME_ZONE.US_CENTRAL, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.TN ]: [ TIME_ZONE.US_EASTERN, TIME_ZONE.US_CENTRAL ],
    [ US_STATE.TX ]: [ TIME_ZONE.US_CENTRAL, TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.UT ]: [ TIME_ZONE.US_MOUNTAIN ],
    [ US_STATE.VT ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.VA ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.WA ]: [ TIME_ZONE.US_PACIFIC ],
    [ US_STATE.WV ]: [ TIME_ZONE.US_EASTERN ],
    [ US_STATE.WI ]: [ TIME_ZONE.US_CENTRAL ],
    [ US_STATE.WY ]: [ TIME_ZONE.US_MOUNTAIN ]
};

export const CITY_TIME_ZONE_TO_TIME_ZONE : {
    [CityTimeZone in CITY_TIME_ZONE] : TIME_ZONE
} = {
    [ CITY_TIME_ZONE.AMERICA_ADAK ]:                  TIME_ZONE.US_HAWAII,
    [ CITY_TIME_ZONE.AMERICA_ANCHORAGE ]:             TIME_ZONE.US_ALASKA,
    [ CITY_TIME_ZONE.AMERICA_CHICAGO ]:               TIME_ZONE.US_CENTRAL,
    [ CITY_TIME_ZONE.AMERICA_DETROIT ]:               TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA ]:               TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_INDIANAPOLIS ]:  TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_KNOX ]:          TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_MARENGO ]:       TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_MICHIGAN_CITY ]: TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_PETERSBURG ]:    TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_TELL_CITY ]:     TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_VEVAY ]:         TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_INDIANA_VINCENNES ]:     TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_JUNEAU ]:                TIME_ZONE.US_ALASKA,
    [ CITY_TIME_ZONE.AMERICA_KENTUCKY_LOUISVILLE ]:   TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_KENTUCKY_MONTICELLO ]:   TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_LOS_ANGELES ]:           TIME_ZONE.US_PACIFIC,
    [ CITY_TIME_ZONE.AMERICA_LOUISVILLE ]:            TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MANAGUA ]:               TIME_ZONE.US_CENTRAL,
    [ CITY_TIME_ZONE.AMERICA_MANAUS ]:                TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MARIGOT ]:               TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MARTINIQUE ]:            TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MATAMOROS ]:             TIME_ZONE.US_CENTRAL,
    [ CITY_TIME_ZONE.AMERICA_MAZATLAN ]:              TIME_ZONE.US_MOUNTAIN,
    [ CITY_TIME_ZONE.AMERICA_METLAKATLA ]:            TIME_ZONE.US_ALASKA,
    [ CITY_TIME_ZONE.AMERICA_MENOMINEE ]:             TIME_ZONE.US_CENTRAL,
    [ CITY_TIME_ZONE.AMERICA_MIQUELON ]:              TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MONCTON ]:               TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_MONTERREY ]:             TIME_ZONE.US_CENTRAL,
    [ CITY_TIME_ZONE.AMERICA_MONTREAL ]:              TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_NEW_YORK ]:              TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_NOME ]:                  TIME_ZONE.US_ALASKA,
    [ CITY_TIME_ZONE.AMERICA_NASSAU ]:                TIME_ZONE.US_EASTERN,
    [ CITY_TIME_ZONE.AMERICA_PHOENIX ]:               TIME_ZONE.US_MOUNTAIN,
    [ CITY_TIME_ZONE.AMERICA_SITKA ]:                 TIME_ZONE.US_ALASKA,
    [ CITY_TIME_ZONE.AMERICA_YAKUTAT ]:               TIME_ZONE.US_ALASKA
};

